export const CUSTOMER_TYPES = ["Persona fisica", "Persona giuridica"]